<template>
  <span class="event-selector">
    <c-selector v-if="ready" :width="width"
                 v-model="targetEvent"
                 :store="groupList"
                 :hidden-group-map="hiddenGroupMap"
                 children-field="eventList"
                 key-field="event_id"
                 :multiple="multiple"
                 label-field="event_name"
                 group-field="groupName"
                 alias-field="alias_name"
                 :placeholder="placeholder"
                 ref="eventSelectComponent"
                 filterOption
                 bindValueWithStore
                 :alwaysExpand="alwaysExpand"
                 :showGroupShortcut="showGroupShortcut"
                 @change="onClickEvent">
      <template slot-scope="scope">
        <i class="icon-star_glyph" v-if="scope.data.mark_type"></i>
         <i :class="scope.data.icon" v-else-if="scope.data.icon"></i>
        <i class="icon-star_line" v-else></i>
        <span :title="scope.data.alias_name || scope.data.event_name">
          <!-- {{strMiddleSplit(scope.data.alias_name || scope.data.event_name)}} -->
          {{strMiddleSplit(`${scope.data.owner === 'zg_vtl' ? '虚拟事件' : '元事件'} | ${scope.data.alias_name || scope.data.event_name}`)}}
        </span>
      </template>

      <template slot="header" slot-scope="scope">
        {{scope.data.groupName}}
      </template>
    </c-selector>
  </span>
</template>

<script>
import {mapState} from 'vuex'
import {actions} from '../../store/constants'
import {util} from '../../utils'
export default {
  name: 'eventSelector',
  props: {
    value: null,
    width: {
      type: Number,
      default: 160
    },
    haveAny: {
      type: Boolean,
      default () {
        return false
      }
    },
    placeholder: {
      type: String,
      default () {
        return '请选择'
      }
    },
    alwaysExpand: {
      type: Boolean,
      default: false
    },
    extendEvents: {
      type: Array,
      default () {
        return []
      }
    },
    filterByPlat: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    platId: { // 私有部署需要传平台，平台id不是全局的数据，所以需要手动传值
      type: Number,
      required: true
    },
    anyLable: {
      type: String,
      default: '任意行为'
    },
    filterByGroupId: { //通过GroupId进行过滤,-2默认为所有分组
      type: Number,
      default: -2
    },
    /**
     * 展示分组标题切换标签，快捷展示数据
     */
    showGroupShortcut: {
      type: Boolean,
      default: false
    },
    /**
     * 过滤xx事件
     */
    filterEventId: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data () {
    return {
      targetEvent: this.value
    }
  },
  computed: {
    ...mapState({
      ready (state) {
        return state.bizSys.ready.eventGroups
      },
      groupList (state) {
        let list = util.clone(sessionStorage.getItem("eventGroupsTemp") ? JSON.parse(sessionStorage.getItem("eventGroupsTemp"))  : state.bizSys.eventGroups)
        let result = []
        let starGroup = {
          groupName: 'star',
          groupId: '',
          event_id: '-999',
          eventList: [].concat(this.extendEvents)
        }
        let extendMap = {}
        this.extendEvents.forEach(event => {
          extendMap[event.event_id] = extendMap
        })
        if (this.haveAny) {
          starGroup.eventList.push({
            event_name: this.anyLable,
            event_id: -1,
            info: [],
            icon: 'icon-list',
          })
        }
        if (list.length > 1) {
          let _eventList = util.clone(sessionStorage.getItem("eventListTemp") ? JSON.parse(sessionStorage.getItem("eventListTemp"))  : state.bizSys.eventList)
          _eventList.forEach(event => {
            if (
              event.mark_type
              && event.event_hidden === 0
              && !event.is_delete
              && !extendMap[event.event_id]
            ) {
              starGroup.eventList.push(event)
            }
          })
        } else if (list.length) {
          list[0].eventList.sort((a, b) => {
            return b.mark_type - a.mark_type
          })
        }
        result.push(starGroup)
        list.forEach(group => {
          let resultGroup = util.clone(group)
          resultGroup.event_id = `group${group.groupId}` // 为了使key-field保持一致
          resultGroup.eventList = []
          group.eventList.forEach(event => {
            if (
              event.event_hidden === 0
              && !event.is_delete
              && !extendMap[event.event_id]
              && (!this.filterByPlat || (this.filterByPlat && [0].concat(event.plats).includes(Number(this.platId))))
            ) {
              if (this.filterEventId.length > 0) {
                // 过滤某些事件
                if (!this.filterEventId.includes(event.event_id))
                  resultGroup.eventList.push(event)
              } else {
                resultGroup.eventList.push(event)
              }
            }
          })
          result.push(resultGroup)
        })

        if (this.filterByGroupId !== -2){
          result = result.filter(group => {
            if (group.groupId === this.filterByGroupId){
              group.eventList.unshift({
                event_name: this.anyLable,
                event_id: -1,
                icon: 'icon-list',
              })
              return true
            }
          })
        }
        return result
      },
      hiddenGroupMap (state) {
        let list = sessionStorage.getItem("eventGroupsTemp") ? JSON.parse(sessionStorage.getItem("eventGroupsTemp"))  : state.bizSys.eventGroups
        let map = {
          '-999': true
        }
        if (list.length === 1) {
          map[`group${list[0].groupId}`] = true // 为了使key-field保持一致
        }
        return map
      }
    })
  },
  watch: {
    value () {
      this.targetEvent = this.value
    },
    targetEvent: {
      deep: true,
      handler (now, pre) {
        if (now && pre && now.event_id === pre.event_id) {
          this.$emit('input', now)
        }
      }
    },
    platId (platId, prePlat) {
      if (Number(platId) === Number(prePlat)) return
      this.queryEvents(true)
    }
  },
  created () {
    if (this.value) {
      this.targetEvent = this.value
    }
    this.queryEvents()
  },
  methods: {
    queryEvents (force = false) {
      this.$store.dispatch(actions.biz.sys.queryEventMeta, {
        appId: sessionStorage.getItem('urlAppId') || this.appId, // 使用全局的计算属性
        platform: this.platId,
        force
      }).catch(err => {
        if (err.__CANCEL__) return
        console.error(err)
      })
    },
    strMiddleSplit (str) {
      if (util.isString(str)) {
        return util.strMiddleSplit(str, {
          maxLength: 50,
          beginLength: 47,
          endLength: 0,
          replaceStr: '...'
        })
      }
      return str
    },
    onClickEvent () {
      this.$emit('input', this.targetEvent)
      this.$emit('change', this.targetEvent)
    },
    filterOption (filter, data) {
      return filter.test(data.event_name) || filter.test(data.alias_name)
    }
  }
}
</script>

<style lang="sass">
@import "styles/index"
</style>
